module.exports = __webpack_public_path__ + "pivot-webfont.5605416c648e5b862738.eot";


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/assets/webix/fonts/pivot-webfont.eot
// module id = ../../../../../src/assets/webix/fonts/pivot-webfont.eot
// module chunks = styles